module.exports = __webpack_public_path__ + "static/amelie_2-c546dd6175443377656f0c09b47ba071.jpg";